import { render, staticRenderFns } from "./vehicleRestrictedAreaStatistics.vue?vue&type=template&id=68972a30&scoped=true"
import script from "./vehicleRestrictedAreaStatistics.vue?vue&type=script&lang=js"
export * from "./vehicleRestrictedAreaStatistics.vue?vue&type=script&lang=js"
import style0 from "./vehicleRestrictedAreaStatistics.vue?vue&type=style&index=0&id=68972a30&prod&lang=scss&scoped=true"
import style1 from "./vehicleRestrictedAreaStatistics.vue?vue&type=style&index=1&id=68972a30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68972a30",
  null
  
)

export default component.exports